import "./sidebar.css";
import { ReactComponent as Logo } from "../icons/gnai_logo.svg";
import { Link, NavLink, useLocation } from "react-router-dom";
import { ReactComponent as DashboardIcon } from "../icons/dashboard.svg";
import { ReactComponent as LogOutIcon } from "../icons/logout.svg";
import { ReactComponent as GridcoIcon } from "../icons/gridco-logo.svg";
import { ReactComponent as HpgclIcon } from "../icons/cerc-dashboard.svg";
import { ReactComponent as RuvitalIcon } from "../icons/ruvital.svg";
import { ReactComponent as GNAiIcon } from "../icons/gnai.svg";
import { ReactComponent as GNAiActiveIcon } from "../icons/gnai-active.svg";
import { ReactComponent as CercIcon } from "../icons/cerc-dashboard.svg";
import { ReactComponent as DmrcIcon } from "../icons/DMRC.svg";
import { ReactComponent as CercActiveIcon } from "../icons/cerc-dashboard-active.svg";
import { ReactComponent as CspdclIcon } from "../icons/Cspdclogo.svg";
import { ReactComponent as JvvnlIcon } from "../icons/jvvnl.svg";
import { useSelector, useDispatch } from "react-redux";
import { ReactComponent as MenuItemIcon } from "../icons/menu-item.svg";
import { RootState } from "../store/store";
import { ReactComponent as GNAIcon } from "../icons/gna.svg";
import { ProtectedPage, setLoggedIn } from "../pages/Protected";
import { useEffect, useState } from "react";
import Model from "../components/Model";
import ReactDOM from "react-dom";
import { setIsOpen } from "../store/state/disclamerModel";
import { Info } from "lucide-react";
import { ReactComponent as BankingIcon } from "../icons/dashboard/exchangeAnalysis.svg";

function SidebarTooltip({
  text,
  isVisible,
  position,
}: {
  text: string;
  isVisible: boolean;
  position: { x: number; y: number };
}) {
  if (!isVisible) return null;

  return ReactDOM.createPortal(
    <div
      style={{
        position: "fixed",
        left: `${position.x + 45}px`,
        top: `${position.y}px`,
        zIndex: 9999,
        animation: "tooltipFadeIn 0.15s ease forwards",
      }}
      className="bg-[#F1935C] text-white p-1 shadow-lg rounded-xl text-xs font-medium px-3"
    >
      <span className="text-start">{text}</span>
    </div>,
    document.body,
  );
}

function SideBarItems({
  Icon,
  text,
  href,
  isMenuActive,
}: {
  Icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  text: string;
  href: string;
  isMenuActive?: boolean;
}) {
  const location = useLocation();

  let isActive = location.pathname.includes(href);
  const [open, SetOpen] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });

  return (
    <>
      <NavLink
        onMouseOver={(e) => {
          SetOpen(true);
          setTooltipPosition({
            x: e.currentTarget.getBoundingClientRect().left,
            y: e.currentTarget.getBoundingClientRect().top,
          });
        }}
        onMouseLeave={() => SetOpen(false)}
        to={href}
        className={`sidebar-item text-[13px] ${
          isActive ? "sidebar-item-active " : ""
        } ${isMenuActive ? "" : "justify-center"}  items-center rounded-lg`}
      >
        {isActive ? (
          <MenuItemIcon fill="#F1935C" />
        ) : (
          <MenuItemIcon fill={"#9F9F9F"} />
        )}

        {isMenuActive && (
          <p
            className="sidebar-text text-[10px] text-[#525062] font-normal"
            style={{ textAlign: "center" }}
          >
            {text}
          </p>
        )}
      </NavLink>

      <SidebarTooltip
        text={text}
        isVisible={!isMenuActive && open}
        position={tooltipPosition}
      />
    </>
  );
}

function SideBarActivateItems({
  Icon,
  ActiveIcon,
  text,
  href,
  isMenuActive,
}: {
  Icon?: any;
  ActiveIcon?: any;
  text: string;
  href: string;
  isMenuActive?: boolean;
}) {
  const location = useLocation();

  const [open, SetOpen] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  const hrefPath = href.split("?")[0];
  let isActive =
    location.pathname.includes(hrefPath) ||
    (location.pathname + location.search).includes(href);

  return (
    <>
      <NavLink
        onMouseOver={(e) => {
          SetOpen(true);
          setTooltipPosition({
            x: e.currentTarget.getBoundingClientRect().left,
            y: e.currentTarget.getBoundingClientRect().top,
          });
        }}
        onMouseLeave={() => SetOpen(false)}
        to={href}
        className={`relative sidebar-item ${
          isActive ? "sidebar-item-active" : ""
        } ${
          isMenuActive ? "" : "justify-center"
        }  items-center rounded-lg text-sm`}
      >
        {isActive ? <ActiveIcon /> : <Icon />}

        {isMenuActive && (
          <p
            className="sidebar-text text-[10px] mt-1 text-[#525062] font-normal"
            style={{ textAlign: "center", lineHeight: "initial" }}
          >
            {text}
          </p>
        )}
      </NavLink>

      <SidebarTooltip
        text={text}
        isVisible={!isMenuActive && open}
        position={tooltipPosition}
      />
    </>
  );
}

function LogOut() {
  const [open, SetOpen] = useState(false);
  // const active = useSelector((state: RootState) => state.menu.isActive);
  const active = true;
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });

  return (
    <div
      onMouseOver={(e) => {
        SetOpen(true);
        setTooltipPosition({
          x: e.currentTarget.getBoundingClientRect().left,
          y: e.currentTarget.getBoundingClientRect().top,
        });
      }}
      onMouseLeave={() => SetOpen(false)}
      className={`sidebar-item items-center rounded-lg`}
      onClick={() => {
        setLoggedIn(false);
        localStorage.clear();
        window.location.href = "/login";
      }}
    >
      <LogOutIcon />

      {active && (
        <p className="sidebar-text text-[10px] text-[#525062] font-normal">
          Logout
        </p>
      )}

      <SidebarTooltip
        text="Logout"
        isVisible={!active && open}
        position={tooltipPosition}
      />
    </div>
  );
}

function Disclamer() {
  const [open, SetOpen] = useState(false);
  // const active = useSelector((state: RootState) => state.menu.isActive);
  const active = false;
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });

  const dispatch = useDispatch();

  return (
    <>
      <div
        onMouseOver={(e) => {
          SetOpen(true);
          setTooltipPosition({
            x: e.currentTarget.getBoundingClientRect().left,
            y: e.currentTarget.getBoundingClientRect().top,
          });
        }}
        onMouseLeave={() => SetOpen(false)}
        className={`sidebar-item items-center rounded-lg cursor-pointer`}
        onClick={() => dispatch(setIsOpen(true))}
        style={{ marginBottom: "0px" }}
      >
        {!active && (
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12 8V12"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12 16H12.01"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}

        {active && (
          <p className="sidebar-text text-[13px] mb-0">
            <Info className="!bg-transparent" />
          </p>
        )}

        <SidebarTooltip
          text="Disclaimer"
          isVisible={!active && open}
          position={tooltipPosition}
        />
      </div>

      {/* Use the Model component instead of the inline modal */}
      <DisclamerModel />
    </>
  );
}

export function DisclamerModel() {
  const openModal = useSelector(
    (state: RootState) => state.disclamerModel.isOpen,
  );
  const dispatch = useDispatch();

  return (
    <Model
      isOpen={openModal}
      onClose={() => dispatch(setIsOpen(false))}
      title="Disclaimer"
      description="GNA Energy Data and Analytics Platform (GNAi)"
    >
      <div className="flex flex-col gap-5 text-[#8C8A96] text-[11px]">
        <p>
          The content available on the{" "}
          <strong>GNA Energy Data and Analytics Platform </strong>
          (hereinafter referred to as <strong>"GNAi"</strong>) and its
          associated website is intended solely for
          <strong> informational purposes</strong>. While{" "}
          <strong>GNA Energy</strong> makes every effort to present accurate,
          reliable, and up-to-date data, the company{" "}
          <strong>does not guarantee</strong> the completeness, accuracy, or
          timeliness of the information. GNA Energy explicitly disclaims any
          responsibility for{" "}
          <strong>errors, omissions, or inaccuracies </strong> in the content.
        </p>

        <p>
          Users are advised to verify the information provided through other
          sources before making any decisions based on the content available on
          GNAi. The reliance on the data and analysis provided is at the user's
          own risk. GNA Energy shall not be liable for any{" "}
          <strong>loss, damage, or inconvenience</strong> arising from the use
          of the information available on GNAi.
        </p>

        <p>
          The content on GNAi, including but not limited to text, graphics,
          data, analysis, and charts, is protected by{" "}
          <strong>
            copyright and is the intellectual property of GNA Energy
          </strong>
          . Any unauthorized reproduction, distribution, or use of the content
          without prior written permission from GNA Energy is strictly
          prohibited.
        </p>
      </div>
    </Model>
  );
}

export function Sidebar2() {
  // const active = useSelector((state: RootState) => state.menu.isActive);
  const active = true;

  useEffect(() => {
    document.body.classList.toggle("sidebar-expanded", active);
    return () => {
      document.body.classList.remove("sidebar-expanded");
    };
  }, [active]);

  return (
    <div
      style={{
        minWidth: active ? "76px" : "60px",
        width: active ? "76px" : "60px",
      }}
      className="sidebar transition-all duration-300 ease-in-out flex flex-col h-screen shadow-sm"
    >
      {/* <div className="flex justify-center flex-col items-center flex-shrink-0">
        <Link to={"/"}>
          {active ? (
            <div key="full-logo" className="sidebar-logo-enter">
              <Logo width={64} />
            </div>
          ) : (
            <div key="icon-logo" className="sidebar-logo-enter">
              <GNAIcon />
            </div>
          )}
        </Link>
        <hr
          className="border-t border-gray-300 w-full"
          style={{ color: "#E4E7ED", marginTop: active ? "11px" : "15px" }}
        />
      </div> */}

      <div className="sidebar-items flex flex-col flex-1 overflow-hidden">
        <div className="flex-1 overflow-y-auto scrollbar-container">
          <SideBarItems
            Icon={DashboardIcon}
            text="Dashboard"
            href="/dashboard"
            isMenuActive={active}
          />
          {/* <ProtectedPage showPopUp={false} pageId="gnai">
          <SideBarActivateItems
            Icon={GNAiIcon}
            ActiveIcon={GNAiActiveIcon}
            text="GNAi"
            isMenuActive={active}
            href="/document"
          /></ProtectedPage> */}
          <ProtectedPage showPopUp={false} pageId="cerc">
            <SideBarActivateItems
              Icon={CercIcon}
              ActiveIcon={CercActiveIcon}
              text="CERC Monitor"
              href="/marketMonitoring"
              isMenuActive={active}
            />
          </ProtectedPage>
          <ProtectedPage showPopUp={false} pageId="dmrc">
            <SideBarActivateItems
              Icon={DmrcIcon}
              ActiveIcon={DmrcIcon}
              text="DMRC"
              href="/dmrc"
              isMenuActive={active}
            />
          </ProtectedPage>
          <ProtectedPage showPopUp={false} pageId="rajasthan">
            <SideBarActivateItems
              Icon={RuvitalIcon}
              ActiveIcon={RuvitalIcon}
              text="RUVITL"
              href="/ruvnl"
              isMenuActive={active}
            />
          </ProtectedPage>
          <ProtectedPage showPopUp={false} pageId="jvvnl">
            <SideBarActivateItems
              Icon={JvvnlIcon}
              ActiveIcon={JvvnlIcon}
              text="JVVNL"
              href="/jvvnl"
              isMenuActive={active}
            />
          </ProtectedPage>
          <ProtectedPage showPopUp={false} pageId="gridco">
            <SideBarActivateItems
              Icon={GridcoIcon}
              ActiveIcon={GridcoIcon}
              text="GRIDCO"
              href="/gridco"
              isMenuActive={active}
            />
          </ProtectedPage>
          <ProtectedPage showPopUp={false} pageId="cg">
            <SideBarActivateItems
              Icon={CspdclIcon}
              ActiveIcon={CspdclIcon}
              text="CSPDCL"
              href="/CSPDCL"
              isMenuActive={active}
            />
          </ProtectedPage>
          {/*<ProtectedPage showPopUp={false} pageId="banking">
            <SideBarActivateItems
              Icon={CercIcon}
              ActiveIcon={CercIcon}
              text="Banking Calculator"
              href="/banking"
              isMenuActive={active}
            />
          </ProtectedPage> */}
          <ProtectedPage showPopUp={false} pageId="hppc">
            <SideBarActivateItems
              Icon={CercIcon}
              ActiveIcon={CercActiveIcon}
              text="HPPC"
              href="/hppc"
              isMenuActive={active}
            />
          </ProtectedPage>
          <ProtectedPage showPopUp={false} pageId="demoState">
            <SideBarActivateItems
              Icon={CercIcon}
              ActiveIcon={CercActiveIcon}
              text="Power Analytics"
              href="/demo?tab=dashboard"
              isMenuActive={active}
            />
          </ProtectedPage>
          <LogOut />
        </div>

        <div className="flex flex-col items-center mb-1">
          <Disclamer />
        </div>
      </div>
    </div>
  );
}

export default Sidebar2;
